<template>
  <k-row>
    <k-col span="8">
      <a
        href="javascript:;"
        x-click="go.home"
        data-app-name="XuanShang"
        :data-web-url="homeUrl"
        title="玄商拍客"
      >
        <img
          class="xs-logo"
          src="https://staticcdn-yy-prd.pydp888.com/xs/pai/1.0.0-alpha/home/img/logo_m.png?v=20200416"
        />
      </a>
    </k-col>
    <k-col span="16" class="search-box">
      <div class="search-bar">
        <div class="search-bar__inner">
          <div class="am-dropdown" data-am-dropdown="">
            <k-button
              class="sltbtn"
              type="default"
              size="small"
              @click="showSelect"
              >{{ sltText }}▾</k-button
            >
            <transition name="k-fade">
              <ul class="am-dropdown-content" v-show="showMenu">
                <li :class="{ active: source === 0 }" @click="selectItem(0)">
                  <a href="javascript:;" data-source="0">拍品</a>
                </li>
                <li :class="{ active: source === 2 }" @click="selectItem(2)">
                  <a href="javascript:;" data-source="2">店铺</a>
                </li>
                <li :class="{ active: source === 3 }" @click="selectItem(3)">
                  <a href="javascript:;" data-source="3">专家</a>
                </li>
              </ul>
            </transition>
          </div>
          <div class="search-bar__input">
            <input
              id="searchInput"
              v-model="keyword"
              @input="oninput"
              @keyup.enter="search"
              class="search-key"
              name="keyword"
              type="search"
              placeholder="输入关键字"
              maxlength="15"
              value=""
              autocomplete="off"
            />
          </div>
          <button
            type="submit"
            id="ai-topsearch"
            class="search-bar__submit"
            @click="search"
          >
            搜索
          </button>
        </div>
      </div>
    </k-col>
  </k-row>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { HOST_WEB, HOST_PAI } from '../../utils/xp.v1'

export default {
  name: 'jd-shbar',
  props: ['value'],
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      showMenu: false,
      source: 3,
      keyword: this.$route.query.keyword || '',
      sourceMap: {
        0: '拍品',
        2: '店铺',
        3: '专家',
      },
    }
  },
  computed: {
    ...mapState('jianding', ['searchKey']),
    homeUrl() {
      return `https://${HOST_WEB}`
    },
    sltText() {
      let { sourceMap, source } = this
      return sourceMap[source]
    },
    paiSearchUrl() {
      return `https://${HOST_PAI}/v1/Index/search.html`
    },
  },
  methods: {
    ...mapMutations('jianding', ['setKeyword']),
    showSelect() {
      this.showMenu = !this.showMenu
    },
    selectItem(type) {
      this.source = type
      this.showMenu = false
    },
    oninput() {},
    search() {
      let { paiSearchUrl, source, keyword } = this
      this.$emit('search', { keyword })
      if (source === 3) {
        this.$router.push({ path: `/list?keyword=${keyword}` })
      } else {
        location.href = `${paiSearchUrl}?source=${source}&keyword=${keyword}`
      }
    },
  },
  watch: {
    keyword(nv) {
      if (nv) {
        this.setKeyword({ keyword: nv })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.search-box {
  padding: 0.1rem 0.2rem 0 0.1rem;
}
.xs-logo {
  //height: 0.7rem;
}
.search-bar {
  background: #cea065;
  padding: 2px;
  &__inner {
    width: 100%;
    position: relative;
    height: 0.58rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    justify-content: space-between;
    box-sizing: border-box;
    background: #000;
    overflow: hidden;
  }
  &__input {
    flex: 1;
    background: #fff;
  }

  .search-key {
    outline: 0;
    border: 0;
    background: transparent;
    padding-left: 0.2rem;
    height: 0.6rem;
    line-height: 0.6rem;
    border-width: 0;
    margin: 0;
    min-width: 1rem;
  }

  &__submit {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #cea065;
    border: 0;
    border-radius: 0;
    font-size: 0.24rem;
    color: #fff;
    height: 100%;
    margin: 0;
    width: 0.8rem;
    border-width: 0;
  }
}

.sltbtn {
  background: #ddd;
  border: 0;
  font-size: 0.24rem;
  border-radius: 0;
  height: 100%;
  margin: 0;
}
.am-dropdown {
  position: relative;
  width: 1rem;
  height: 100%;
}
.am-dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 2;
  padding: 0;
  margin: 0.15rem 0 0;
  line-height: 1.6;
  min-width: 1.5rem;
  background-color: #fff;
  border: 1px solid #ddd;
  a {
    display: block;
    padding: 0.15rem;
  }
  li.active a {
    background: #cea065;
    color: #fff;
  }
}
.am-dropdown-content :first-child {
  margin-top: 0;
}
.am-dropdown-content:before,
.am-dropdown-content:after {
  position: absolute;
  display: block;
  content: '';
  width: 0;
  height: 0;
  border: 8px dashed transparent;
  z-index: 1;
}
.am-dropdown-content:before {
  border-bottom-color: #fff;
  bottom: 0;
  left: 0.2rem;
  top: -0.3rem;
  pointer-events: none;
}
.am-dropdown-content:after {
  top: -7px;
  left: 0.15rem;
  pointer-events: none;
}
</style>
